import type { CommitLocationOptions } from "@tanstack/react-router";

/**
 * TanStack resets scroll on every navigate, which is wrong where the chosen record is a search
 * param: picking a row is a change within the page. Spread this for same-screen navigation only.
 */
export const keepScrollPosition: CommitLocationOptions = { resetScroll: false };
